import cn from 'classnames';

import SectionTitle from 'components/checkout/caap/SectionTitle';
import { Spinner } from 'components/Loader';
import css from 'styles/components/checkout/caap/stepSection.scss';

const StepSection = params => {
  const {
    addOverlay,
    children,
    hideContent,
    isCurrentStep,
    linkText,
    linkTo,
    noBorder,
    onLinkClick,
    showLink,
    showTitleBar,
    stepClass,
    stepNumber,
    title,
    dataTestIdLoader
  } = params;

  const sectionStyles = cn(css.checkoutSection, {
    [css.noBorder]: noBorder,
    [css.sectionOverlay]: addOverlay,
    [stepClass]: stepClass,
    [css.active]: isCurrentStep
  });

  const mobileSpinnerStyles = cn(css.checkoutSpinner, {
    [css.active]: !!addOverlay
  });

  return (
    <div className={sectionStyles}>
      <div className={mobileSpinnerStyles} data-test-id={dataTestIdLoader}>
        <Spinner viewBox="50" strokeWidth="3" size="100" />
      </div>
      <SectionTitle
        active={isCurrentStep}
        linkText={linkText}
        linkTo={linkTo}
        onLinkClick={onLinkClick}
        showLink={showLink}
        showTitleBar={showTitleBar}
        stepNumber={stepNumber}
        title={title} />
      {
        hideContent
          ? null
          : children
      }
    </div>
  );
};

export default StepSection;
